export const PROCEED_EVENT_NAME = 'proceed'
export const LOAD_EVENT_NAME = 'load'
export const UAE_PHONE_CODE = 'QA'
export const POPULAR_NATIONALITIES_LIMIT = 6
